<template>

    <div class="d-flex min-vh-100 bg-primary">
        <div class="d-flex flex-column py-4 justify-content-center align-items-center flex-grow-1 bg-white border rounded-right">
            <div class="my-auto" style="max-width:546px; width:100%;">
                    <div class="d-flex flex-column justify-content-center ">

                        <Logo :organization="whitelabel" v-if="whitelabel"/>
                        <div v-else>
                            <svg class="w-100" xmlns="http://www.w3.org/2000/svg" width="70" height="70" viewBox="0 0 35.378 39.315" >
                                <g id="Grupo_69" data-name="Grupo 69" transform="translate(-481.81 380)">
                                    <g id="Grupo_68" data-name="Grupo 68" transform="translate(481.81 -380)">
                                        <rect id="Retângulo_39" data-name="Retângulo 39" width="5.56" height="22.238"
                                                transform="translate(31.447 19.656) rotate(45)" fill="#00dbf9"></rect>
                                        <path id="Caminho_94" data-name="Caminho 94"
                                                d="M509.329-372.137l-3.931-3.931L501.466-380l-3.931,3.931-3.931,3.931-3.931,3.931-3.931,3.931-3.931,3.931,3.931,3.931,7.863,7.863,3.931-3.931,3.931-3.931,3.931-3.931,3.931-3.931,3.931-3.931Zm-11.794,11.794-3.931,3.931-3.931-3.931,3.931-3.931,3.931-3.931,3.931-3.931,3.931,3.931Z"
                                                transform="translate(-481.81 380)" fill="#3839e3"></path>
                                        <rect id="Retângulo_40" data-name="Retângulo 40" width="5.56" height="11.119"
                                                transform="translate(11.792 31.453) rotate(-45)" fill="#0195ff"></rect>
                                    </g>
                                </g>
                            </svg>
                        </div>

                        <div class="text-center mt-2">
                            <strong class="h4" v-if="!whitelabel">Boas vindas a plataforma E-correção</strong>
                            <strong class="h4" v-else>Boas vindas a nossa plataforma</strong>
                            <p>
                                <small>Antes de entrar, selecione o tipo de perfil e em seguida preencha os dados solicitados.</small>
                            </p>
                        </div>
                    </div>

                    <div class="rounded-pill d-flex justify-content-around p-2 bg-light ">
                        <div id="btnTeacher" @click="()=>{ this.isTeacher ? '' : this.isTeacherToggle() }" role="button" class="trasition bg-white border border-primary rounded-pill text-primary text-center py-2 px-5 flex-grow-1" >
                            Professor
                        </div>
                        <div id="btnStudent" @click="()=>{ !this.isTeacher ? '' : this.isTeacherToggle() }" role="button" class="border border-light rounded-pill text-primary text-center py-2 px-5 flex-grow-1">
                            Aluno
                        </div>
                    </div>

                    <form @submit.prevent="onSubmit" class="container align-self-center">
                        <div class="form-group">
                            <label for="form-label">Email</label>
                            <input
                            type="text"
                            class="form-control"
                            :class="errors.email? 'is-invalid' : ''"
                            autofocus
                            autocomplete="email"
                            placeholder="Digite seu email"
                            required
                            v-model="form.email">

                            <span v-show="errors.email.length>0">
                                <strong class="text-danger">{{errors.email[0]}}</strong>
                            </span>
                        </div>

                        <div class="form-group">
                            <label for="form-label">Senha</label>
                            <input
                            type="password"
                            class="form-control"
                            placeholder="Digite sua senha"
                            required
                            v-model="form.password">
                        </div>
                        <div class="d-flex justify-content-between mb-3">
                            <div class="form-check d-flex align-items-center" >
                                <input class="form-check-input" type="checkbox" id="remenberCheck" v-model="form.remember">
                                <label class="form-check-label" for="remenberCheck" role="button" ><small>Manter conectado</small></label>
                            </div>
                            <a :href="isTeacher? endpointPasswordTeacher : endpointPasswordStudent"><small>Esqueceu a senha?</small></a>

                        </div>

                        <button type="submit" :disabled="isSubmiting" class="w-100 btn btn-primary rounded-pill"><strong>Entrar</strong></button>
                    </form>
                    <p class="text-center mt-2"><small>Não possui uma conta? <a :href="isTeacher? endpointRegisterTeacher : endpointRegisterStudent">registre-se</a></small></p>

            </div>
            <div class="mt-auto mb-0">
                <a class="d-flex justify-content-center align-items-center gap-2" href="https://ecorrecao.com.br/">

                    <div class="text-dark"><small class="h6">Software</small></div>
                    <img width="100" src="/img/ecorrecao-brand.png" alt="">
                </a>
            </div>
        </div>
        <div class="bg-primary flex-lg-grow-1 flex-md-grow-0 side-image">
            <div v-if="whitelabel"  class="position-relative h-100 overflow-hidden">
                <img  class="object-fit-none  w-100 position-absolute top-50 start-50 translate-middle" :src="whitelabel.auth_bg_preview" alt=""/>
            </div>
            <div v-else class="decoration-none d-flex align-items-bottom position-relative h-100 w-100">

                <img  class="object-fit-contain position-absolute bottom-0 start-50 translate-middle-x" src="/img/login.png" alt=""/>
            </div>
        </div>
    </div>

</template>

<script>
import Logo from './Logo.vue'
export default {
    props: ['endpointStudent', 'endpointTeacher', 'organization', 'endpointRegisterTeacher', 'endpointRegisterStudent', 'endpointPasswordTeacher', 'endpointPasswordStudent', 'pageFor'],
    components: {
        Logo
    },
    data (){
        return {
            whitelabel: null,
            isTeacher: true,
            isSubmiting : false,
            form: {
                email: '',
                password: '',
                remember : false
            },
            errors: {
                email: ''
            },

        }
    },
    created(){
        this.whitelabel = JSON.parse(this.organization);
        if(this.pageFor ==='student') this.isTeacher =false;
    },
    watch: {
        isTeacher (){
            this.activeButton()
        }
    },
    methods: {
        onSubmit() {
            this.isSubmiting = true
            let submitUrl = this.isTeacher ? this.endpointTeacher : this.endpointStudent
            this.errors = {}

            if(this.form.email === '' || this.form.password === ''){

            }

                axios.post(submitUrl, {
                email: this.form.email,
                remember: this.form.remember,
                password: this.form.password,

            })
            .then((res)=>{
                window.location.replace(submitUrl)
            })
            .catch((err)=>{
                this.errors = err.response.data.errors
            })
            .finally(()=>{
                this.isSubmiting = false
            })
        },

        isTeacherToggle () {
            this.isTeacher = !this.isTeacher;
        },
        activeButton (){
            const active = ['bg-white', 'border-primary','transition']
            let teacher = document.getElementById('btnTeacher')
            let student = document.getElementById('btnStudent')

            if(this.isTeacher){
                student.classList.remove(...active)
                student.classList.add('border-light')
                teacher.classList.remove('border-light')
                teacher.classList.add(...active)
            }
            else{
                teacher.classList.remove(...active)
                teacher.classList.add('border-light')
                student.classList.remove('border-light')
                student.classList.add(...active)
            }
        }
    }

}
</script>

<style scoped>
    .transition {
        transition: all ease-in-out 1s;
        opacity: 80%;
    }

    .side-image {
        max-width: 900px;
        width: 500px;
    }
    .image-size {
        max-width: 100%;
        background-size: contain;
        background-repeat: no-repeat;
    }

    @media (max-width: 1080px) {
        .side-image {
            display: none;
            width: 500px;
        }
    }

    .decoration-none,
    .decoration-none:hover,
    .decoration-none:link,
    .decoration-none:active,
    .decoration-none:visited{
        text-decoration: none;
    }

</style>
